export default (tourCriteria) => {
    const tourCriteriaJson = {};
    const element = tourCriteria.get('departureCity');
    if (element) {
        tourCriteriaJson.departureCity = element.get('id');
    }

    return tourCriteriaJson;
};